<script>
    import { createEventDispatcher } from 'svelte';
    export let value = undefined;

    const dispatch = createEventDispatcher();
    const handleChange = () => dispatch('change', value);
</script>

<input type="date" bind:value on:change={handleChange} {...$$restProps} />

<style>
    input {
        border-radius: 3px;
        border: 2px solid #ddd;
        width: 100%;
        height: 40px;
    }
</style>
